import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagPermitirIngresoSoloConOCFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagPermitirIngresoSoloConOC'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagPermitirIngresoSoloConOC'
          label='Permitir ingreso a almacén solo con O/C provisionada'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagPermitirIngresoSoloConOCFormGroup)
